"use strict";
"use client";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
exports.__esModule = true;
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
const Coupon = ({
  children,
  dataTest,
  id
}) => /*#__PURE__*/React.createElement("mark", {
  className: "orbit-coupon text-small border-cloud-dark py-50 px-100 rounded-100 text-ink-dark inline border border-dashed bg-transparent font-medium uppercase tracking-[0.75px]",
  "data-test": dataTest,
  id: id
}, children);
var _default = exports.default = Coupon;